@if (loader.isLoading()) {
  <div class="global-loader-overlay" aria-live="polite" aria-busy="true">
    <mat-spinner diameter="64" strokeWidth="8"></mat-spinner>
  </div>
}
